<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="@/common/imgs/news.jpg" alt="">
    </div>

    <!-- content -->
    <div class="news-newslist">
      <div class="new-detail">
        <h3>{{title}}</h3>
        <h4>{{subtitle}}</h4>
        <el-divider content-position="center"><i class="el-icon-time"></i> {{time | subTime}}</el-divider>
        <div class="new-txts" v-html="content"></div>
      </div>
    </div>
     <!-- 回到顶部 -->
    <el-backtop></el-backtop>
    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'Detail',
    data() {
      return {
        nwiId: this.$route.query.id,
        total: this.$route.query.total, //篇数
        title: '', //标题
        subtitle: '', //副标题
        time: '',//发布时间
        content: '' //内容
      }
    },
    mounted() {
      // 请求公司新闻详情
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findById?id=' + this.nwiId).then((response) => {
        this.title = response.data.subject.title;
        this.subtitle = response.data.subject.subtitle;
        this.time = response.data.subject.createTime;
        this.content = response.data.subject.content;
      });
    },
    methods: {

    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    filters: {
      subTime: function(str) {
        return str.substr(0, 10)
      }
    }
  }
</script>
<style scoped>
  @media screen and (max-width: 1120px){
    #footer {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue